/**
 * Public API base URL for places that need it without importing the
 * axios instance (audio players, login redirect, etc.).
 */
export function apiBaseUrl(): string {
  return import.meta.env.VITE_API_URL ?? "";
}
